import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { NoteDTO, NoteWriteDTO } from '../interfaces/note';
import { Observable, of } from 'rxjs';
import { EventDTO, EventViewDTO } from '../interfaces/event';

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  constructor(private dataService: DataService) { }

  saveNote(noteId: number, note: NoteWriteDTO): Observable<NoteDTO> {
    if (noteId && noteId > 0) {
      return this.dataService.updateNote(noteId, note);
    } else {
      return this.dataService.createNote(note);
    }
  }

  deleteNote(note: NoteDTO): Observable<any> {
    if (note && note.id != null && note.id > 0) {
      return this.dataService.deleteNote(note.id);
    } else return of(null);
  }

  getNotes(calendarId: number): Observable<any> {
    return this.dataService.getNotes(calendarId);
  }

  getNotesForCalendar(calendarId: number): Observable<any> {
    return this.dataService.getNotesForCalendar(calendarId);
  }

  getNote(noteId: number): Observable<any> {
    return this.dataService.getNote(noteId);
  }

  searchNotes(calendarId: number, searchTerm: string): Observable<NoteDTO[]> {
    return this.dataService.searchNotes(calendarId, searchTerm);
  }

  createNoteForUpcomingEvent(calendarId: number, upcoming: EventDTO, timeZone: string): Observable<any> {
    return this.dataService.createNoteForUpcomingEvent(calendarId, upcoming, timeZone);
  }

  createNoteForEvent(eventId: number, startDateISO: string): Observable<any> {
    return this.dataService.createNoteForEvent(eventId, startDateISO);
  }

  getRevisions(calendarId: number, uuid: string): Observable<NoteDTO[]> {
    return this.dataService.getRevisions(calendarId, uuid);
  }

  hasRevisions(calendarId: number, uuid: string): Observable<number> {
    return this.dataService.hasRevisions(calendarId, uuid);
  }

  toogleArchive(noteId: number): Observable<any> {
    return this.dataService.toggleArchive(noteId);
  }

}
